import UpsellList from "./Partials/UpsellsList";

export default function Offers() {
  return (
    <div className='w-full max-w-6xl mx-auto'>
      <div className='mt-8'>
        <UpsellList />
      </div>
    </div>
  );
}
